<!--题型 +分数 -->
<template>
  <div class="question-type" :class="{ 'mobile-question-type-wrap': isMobile }">
    <!--题型  -->
    <div
      v-if="info.question_type && QUESTION_TYPE[info.question_type]"
      class="type"
      :style="typeStyle(info.question_type)"
    >
      {{ QUESTION_TYPE[info.question_type] }}
    </div>
    <!-- 分值 -->
    <div v-if="info.score" class="score-value">{{ info.score }} 分</div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
  QUESTION_TYPE,
  QUESTION_TYPE_COLOR,
  QUESTION_TYPE_BG_COLOR,
} from "@saas/components/src/constants/question";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      QUESTION_TYPE,
      QUESTION_TYPE_COLOR,
      QUESTION_TYPE_BG_COLOR,
    };
  },
  computed: {
    ...mapState("defaultHomework", ["isMobile"]),
    typeStyle() {
      return (value) => {
        return {
          color: QUESTION_TYPE_COLOR[value],
          background: QUESTION_TYPE_BG_COLOR[value],
        };
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.question-type {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .type {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 22px;
    background: #e8fffb;
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #0fc6c2;
    line-height: 1;
    margin-right: 6px;
    padding: 0 6px;
  }
  .score-value {
    font-weight: 500;
    font-size: 14px;
    color: #4e5969;
    line-height: 20px;
  }
}

//移动端样式
.question-type.mobile-question-type-wrap {
  margin-bottom: 0.27rem;
  .type {
    min-width: 1.07rem;
    height: 0.59rem;
    border-radius: 0.11rem;
    font-size: 0.37rem;
    margin-right: 0.16rem;
    padding: 0 0.16rem;
  }
  .score-value {
    font-weight: 500;
    font-size: 0.37rem;
    color: #4e5969;
    line-height: 0.53rem;
  }
}
</style>
